// Shared form styles for the redesigned ("melt") screens: onboarding, tracker
// and their dialogs. Class strings, so they compose with cn().

export const MELT_INPUT =
  "h-11 w-full rounded-[10px] border border-melt-hair bg-white px-3.5 text-sm text-melt-text1 outline-none transition-shadow placeholder:text-melt-text3 focus:border-melt-caramel focus:shadow-[0_0_0_3px_rgba(217,136,41,.15)]";

export const MELT_TEXTAREA =
  "w-full resize-none rounded-[10px] border border-melt-hair bg-white px-3.5 py-2.5 text-sm leading-relaxed text-melt-text1 outline-none transition-shadow placeholder:text-melt-text3 focus:border-melt-caramel focus:shadow-[0_0_0_3px_rgba(217,136,41,.15)]";

export const MELT_LABEL = "text-sm font-semibold text-melt-text1";

/** Caramel asterisk after a required field's label. Optional fields get nothing. */
export const MELT_REQUIRED = "ml-0.5 text-melt-caramel";

export const MELT_CHIP =
  "rounded-[10px] border border-melt-hair bg-white px-[13px] py-2 text-[13.5px] font-medium text-melt-text2 transition-all duration-150 hover:border-melt-text1/25 hover:text-melt-text1";
export const MELT_CHIP_ON = "border-melt-caramel bg-melt-peach text-melt-text1 hover:border-melt-caramel";

export const MELT_BUTTON =
  "inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-melt-caramel px-5 text-[15px] font-medium text-white transition-[background-color,opacity] duration-150 hover:bg-melt-press disabled:cursor-default disabled:opacity-45 disabled:hover:bg-melt-caramel";

/** White button for a secondary action: Applied on Home, Mark applied on a draft. Hover fills it beige. */
export const MELT_BUTTON_WHITE =
  "inline-flex items-center justify-center gap-2 border border-melt-line bg-white font-medium text-melt-text1 transition-colors hover:border-melt-text1/20 hover:bg-melt-sidebar disabled:cursor-default disabled:opacity-45";

export const MELT_BUTTON_QUIET =
  "inline-flex h-11 items-center justify-center rounded-xl px-4 text-[15px] font-medium text-melt-text2 transition-colors hover:bg-melt-text1/[.05] hover:text-melt-text1 disabled:opacity-50";

/** Dialog shell: paper background, soft border, warm shadow. */
export const MELT_DIALOG =
  "block max-w-[520px] rounded-[20px] border-melt-hair bg-melt-paper p-0 font-grotesk text-melt-text1 shadow-[0_30px_60px_-30px_rgba(92,52,23,.45)]";
